import { NgModule, ChangeDetectorRef, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Component, Inject, Renderer2, ElementRef} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import config from 'config/default.json';
import { finalize, catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
declare var $: any;

@Injectable()
export class ClassifyService { 
  constructor(
    private helper: HelperModule,
    private apiService: ApiServiceModule,
    public dialog: MatDialog
    ) {}
    that: any;
    init(that:any){
      this.that = that;
    }

    showClassified(){
      this.that.inProgress = true;
      
      /* this.that.editedActive = false;
      this.that.splittedActive = false;
      this.that.classifiedActive = true;
      this.that.activatePage('task-classified');
      this.that.projectInfos['last_task'] = 'task-classified' */
      
      let project = this.that.projectInfos;
      let data = {
        platform_infos: this.that.platformInfos,
        project: project,
        filter_values: this.that.platformInfos['origin'] == 'virtualclass'? {id_country: project.id_country, id_cycle: project.id_cycle, id_region: project.id_region, id_vcl_institution : project.id_vcl_institution}: null,
      };
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/project/load_classify_data', data, this.that.userInfos['access_token']).subscribe((response:any)=>{
     
        this.that.inProgress = false;
        //this.that.projectInfos['last_task'] = 'task-classified'
        this.that.classifyData = response;
        this.that.activatePage('task-classified');
        this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/project/save_current_task', {id_project: this.that.projectInfos['id'], cuurent_task: 'task-classified', platform_infos: this.that.platformInfos}, this.that.userInfos['access_token']).subscribe();
      })
    }

    computeClassification(contentSource: string){
      if(this.that.contentData.length){
        const dialogRef = this.dialog.open(DialogComponent, {
          width: '50%',
          position: {top: '30px' },
          data: {page: 'confirmation', text: 'This action will erase your previous Classification... Continue ?'}
        });
        dialogRef.afterClosed().subscribe((toContinue:boolean) => {
          if(toContinue){
            this.that.inProgress = true;
            let contentsInfos = {
              content_source: contentSource,
              platform_infos: this.that.platformInfos,
              user_infos: this.that.userInfos,
              project_infos: this.that.projectInfos
            };
            const formData = new FormData();
            formData.append('data', JSON.stringify(contentsInfos));
            
            this.apiService.queryData(config.master.flapi.url + '/enovsky/classify_content', formData, this.that.userInfos['access_token']).subscribe((response:any)=>{
              this.that.inProgress = false;
              this.that.projectInfos['last_task'] = 'task-classified';
              this.that.classifyData = response;
              this.showClassified();
            })
          }
        })
        
      }else this.helper.showToast('Edited content not exist...');
    }
    deleteProject(action: string){
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '60%',
        position: {top: '30px' },
        data: {page: 'confirmation', text: action == 'delete_project_without_ressource'? 'Your are about to delete this project and its contents...':  (action == 'delete_project_with_ressource'? 'Your are about to delete this project, contents and its ressources...': 'You are about to archive this prject')}
      });
      dialogRef.afterClosed().subscribe((confirm:boolean) => {
        if(confirm){
          let data = {
            action: action,
            project: this.that.projectInfos,
            user_infos: this.that.userInfos,
            platform_infos: this.that.platformInfos
          }
          this.apiService.queryData(config.master.ndapi.url +'/enovsky/web/project/action', data, this.that.userInfos['access_token']).subscribe((response:any)=>{
            this.helper.showToast(response.message);
          })
        }
      });
    }
    
    
}
